<template>
  <v-container
    fill-height
    fluid
  >
    <v-layout
      v-if="!$apollo.loading && getWhiteLabel"
      wrap
    >
      <v-flex
        xs12
        md4
        mb-0
        mt-0
        pb-0
      >
        <h2>{{ $t('withdrawals.withdrawals') }}</h2>
      </v-flex>
      <v-flex
        md4
        xs12
        mb-0
        mt-0
        :class="!$vuetify.breakpoint.xs && !$vuetify.breakpoint.sm ? 'pt-3': 'pt-0'"
        pb-0
      >
        <v-text-field
          v-model.trim="search"
          name="search"
          max-length="100"
          style="width:220px;"
          :style="!$vuetify.breakpoint.xs && !$vuetify.breakpoint.sm ? 'margin: 0 auto;' : ''"
          prepend-inner-icon="mdi-text-box-search-outline"
          @change="reload()"
        >
          <template v-slot:append>
            <v-icon
              v-if="search"
              style="cursor:pointer"
              @click="search = null;reload()"
            >
              mdi-close
            </v-icon>
          </template>
        </v-text-field>
      </v-flex>
      <v-flex
        md4
        xs12
        mb-0
        mt-0
        pb-0
        :class="
          !$vuetify.breakpoint.xs && !$vuetify.breakpoint.sm
            ? 'pt-6 text-right'
            : 'pb-5'
        "
      >
        <v-btn
          v-if="gatewayCPAY"
          outlined
          text
          small
          @click="automation()"
        >
          {{ $t('withdrawals.automationButton') }}
        </v-btn>
      </v-flex>
      <v-flex
        v-if="!$apollo.loading"
      >
        <v-card>
          <v-flex v-if="whiteLabelWithdrawals">
            <v-data-table  
              v-if="whiteLabelWithdrawals.data.length > 0" 
              :class="$vuetify.breakpoint.xs ? '' : 'text-no-wrap'" 
              :headers="headers"
              :footer-props="{
                'items-per-page-options': [10, 15, 25, 50, 100, 200]
              }"
              :single-expand="true"
              show-expand
              :locale="$i18n.locale"
              :items="whiteLabelWithdrawals.data"
              :items-per-page="whiteLabelWithdrawals.per_page"
              :page="whiteLabelWithdrawals.current_page"
              :server-items-length="whiteLabelWithdrawals.total"
              :hide-default-footer="_.isEmpty(whiteLabelWithdrawals.data)"
              @update:items-per-page="reload($event, 'count')"
              @update:page="reload($event, 'page')"
            >
              <template v-slot:expanded-item="{ item }">
                <td :colspan="headers.length + 1">
                  <v-layout
                    wrap
                    p-5
                  >
                    <v-flex
                      xs12
                      md12
                      mt-5
                      :style="$vuetify.breakpoint.xs ? 'width:200px;': ''"
                    >
                      <small>{{ $t('withdrawals.wallet') }}</small><br>
                      <b
                        style="overflow-wrap: break-word;"
                      >{{ item.wallet_address }}</b>
                      <v-icon
                        v-clipboard:copy="item.wallet_address"
                        style="cursor:pointer; font-size:16px; margin:5px;"
                        @click="copy('wallet_copied')"
                      >
                        mdi-content-copy
                      </v-icon>
                      <small v-if="wallet_copied">{{ $t('globals.copied') }}</small>
                    </v-flex>
                    <v-flex
                      v-if="item.transaction"
                      xs12
                      md12
                      mt-5
                      :style="$vuetify.breakpoint.xs ? 'width:200px;': ''"
                    >
                      <small>{{ $t('withdrawals.txnId') }}</small><br>
                      <b
                        style="overflow-wrap: break-word;"
                      >{{ item.transaction.txn_id }}</b>
                      <v-icon
                        v-clipboard:copy="item.transaction.txn_id"
                        style="cursor:pointer; font-size:16px; margin:5px;"
                        @click="copy('txn_id_copied')"
                      >
                        mdi-content-copy
                      </v-icon>
                      <small v-if="txn_id_copied">{{ $t('globals.copied') }}</small>
                    </v-flex>
                    <v-flex
                      xs12
                      md4
                      mt-5
                      mb-5
                    >
                      <small>{{ $t('withdrawals.fee') }}</small><br>
                      <b>
                        {{ item.fee }}  {{ item.fee_currency }}</b>
                    </v-flex>
                 
                    <v-flex
                      xs12
                      md4
                      mt-5
                      mb-5
                    >
                      <small>{{ $t('withdrawals.blockchain') }}</small><br>
                      <b>
                        {{ item.blockchain }}</b>
                    </v-flex>
                    <v-flex
                      xs12
                      md4
                      mt-5
                      mb-5
                    >
                      <small>{{ $t('withdrawals.completedAt') }}</small><br>
                      <b v-if="item.completed_at">
                        {{ item.completed_at | moment('L LT') }}
                      </b>
                      <b v-else> - </b>
                    </v-flex>
                  </v-layout>
                </td>
              </template>
              <template v-slot:item.id="{ item }">
                <b>{{ item.id }}</b>
              </template>
              <template v-slot:item.user="{ item }">
                <v-layout
                  wrap
                >
                  <v-flex
                    md3
                    xs4
                    mt-4
                    mb-1
                  >
                    <v-avatar
                      v-if="item.user.avatar != null"
                      style="cursor: pointer;"
                      :tile="false"
                      :size="30"
                    >
                      <v-img
                        :src="item.user.avatar"
                        :lazy-src="item.user.avatar"
                        max-height="30"
                        contain
                      />
                    </v-avatar>
                    <v-avatar
                      v-else-if="!$vuetify.breakpoint.xs"
                      style="cursor: pointer;"
                      :tile="false"
                      :size="30"
                      :color="$vuetify.theme.dark ? $vuetify.theme.themes.dark.background : $vuetify.theme.themes.light.background"
                    >
                      <strong>
                        <a>{{ item.user.name | uppercase | substring(0,2) }}</a>
                      </strong>
                    </v-avatar>
                  </v-flex>
                  <v-flex
                    md9
                    xs8
                    mt-2
                    mb-2
                  >
                    <small><b>{{ item.user.name }}</b><br>
                      {{ item.user.email }}</small>
                  </v-flex>
                </v-layout>
              </template>
              <template v-slot:item.created_at="{ item }">
                {{ item.created_at | moment('L') }}
              </template>
              <template v-slot:item.amount="{ item }">
                <b>{{ item.amount }} {{ item.currency }}</b>
              </template>
              <template v-slot:item.status="{ item }">
                <b 
                  :class="colorStatus(item.status)"
                >
                  {{ $t('withdrawals.'+item.status) }} 
                </b>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn
                  v-if="isWithdrawalAutomation ? item.status === 'new':(item.status === 'new' || item.status === 'pending')"
                  outlined
                  text
                  small
                  @click="process(item)"
                >
                  {{ $t('withdrawals.processButton') }}
                </v-btn>
              </template>
            </v-data-table>
          </v-flex>
          <v-flex
            v-if="!$apollo.loading && whiteLabelWithdrawals && whiteLabelWithdrawals.data.length == 0"
            mt-4 
            class="not-found"
          >
            <v-icon>mdi-ghost</v-icon>
            <p>{{ $t('withdrawals.notFound') }}</p>
          </v-flex>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout
      v-if="!getWhiteLabel"
      wrap
      justify-center
    >
      <helper-start-white-label />
    </v-layout>
    <process-dialog
      v-if="selectedWithdrawal"
      :show-dialog="processDialog"
      :withdrawal="selectedWithdrawal"
      @closeProcessDialog="closeProcessDialog"
    />
    <AutomatedPayoutDialog
      v-if="selectedWithdrawal"
      :show-dialog="automatedPayoutDialog"
      :withdrawal="selectedWithdrawal"
      @closeAutomatedPayoutDialog="closeAutomatedPayoutDialog"
    />
    <automation-dialog
      v-if="automationDialog"
      :show-dialog="automationDialog"
      :whitelabel-uuid="params.whitelabel_uuid"
      @closeAutomationDialog="closeAutomationDialog"
    />
  </v-container>
</template>

<script>

import WHITELABEL_WITHDRAWALS_QUERY from '@/graphql/queries/WhiteLabelWithdrawals.gql';
import GATEWAY_CONFIG_QUERY from "@/graphql/queries/GatewayConfig.gql";
import { mapGetters } from 'vuex'
import ProcessDialog from "@/views/Withdrawals/ProcessDialog.vue";
import AutomationDialog from "@/views/Withdrawals/AutomationDialog.vue"
import AutomatedPayoutDialog from "@/views/Withdrawals/AutomatedPayoutDialog.vue";

export default {
  name: 'WhiteLabelWithdrawals',
  components: {
    AutomatedPayoutDialog,
    ProcessDialog,
    AutomationDialog
  },
  data() {
    return {
      processDialog: false,
      automationDialog: false,
      automatedPayoutDialog: false,
      selectedWithdrawal: null,
      selectedAutomationWithdrawal: null,
      loading: false,
      search: null,
      status: "all",
      txn_id_copied: false,
      wallet_copied: false,
      configGateway: null,
      params: {
        whitelabel_uuid: null,
        page: 1,
        count: 25
      },
      headers: [
        {
          sortable: false,
          text: this.$t('withdrawals.id'),
          value: 'id'
        },
        {
          sortable: false,
          text: this.$t('globals.user'),
          value: 'user',
        },
        {
          sortable: false,
          text: this.$t('globals.amount'),
          value: 'amount'
        },
        {
          sortable: false,
          text: this.$t('invoices.created'),
          value: 'created_at',
        },
        {
          sortable: false,
          text: this.$t('invoices.status'),
          value: 'status'
        },
        {
          sortable: false,
          text: '',
          value: 'actions',
        },
      ]
    }
  },
  computed: {
    ...mapGetters('user', ['getUser']),
    ...mapGetters("whitelabel", ["getWhiteLabel"]),
    gatewayCPAY () {
      return this.configGateway &&
        this.configGateway.status === "enabled" &&
        this.configGateway.config.allow_automated_withdrawals;
    },
    isWithdrawalAutomation() {
      return this.getWhiteLabel && this.getWhiteLabel.withdrawal_automation
    }
  },
  watch: {
    getWhiteLabel(){
       this.reload(null, null, this.getWhiteLabel.uuid)
    }
  },
  mounted() {
    if ( this.getWhiteLabel) {
      this.params.whitelabel_uuid = this.getWhiteLabel.uuid
    }
  },
  methods: {
    process(item) {
      this.selectedWithdrawal = item;
      if(this.isWithdrawalAutomation) {
        this.automatedPayoutDialog = true;
        return
      }
      this.processDialog = true;
    },
    automation() {
      this.automationDialog = true;
    },
    closeProcessDialog(val) {
      this.processDialog = val;
      this.selectedWithdrawal = null;
    },
    closeAutomatedPayoutDialog(val) {
      this.automatedPayoutDialog = val;
      this.selectedWithdrawal = null;
    },
    closeAutomationDialog(val) {
      this.automationDialog = val
    },
    copy(value) {
      this[value] = true
      setTimeout(()=>{
         this[value] = false
      }, 800)
    },
    reload(value = null, from = null, uuid = null) {

      if (value && from) {
        this.params[from] = value
      }
      if (uuid) {
        this.params.whitelabel_uuid = uuid
        this.$apollo.queries.whiteLabelWithdrawals.refresh()
        return
      }

      if (this.search) {
        if (this.search.length < 2) {
          return
        }
        this.params.search = this.search
      } else {
        delete(this.params.search)
      }

      if (this.status == "all") {
          delete(this.params.status)
      } else {
         this.params.status = this.status
      }

      this.$apollo.queries.whiteLabelWithdrawals.fetchMore({
        variables: this.params,
        updateQuery: (previousResult, { fetchMoreResult }) => {
          return fetchMoreResult
        },
      })
    },
  },
  apollo: {
    whiteLabelWithdrawals: {
      query: WHITELABEL_WITHDRAWALS_QUERY,
      fetchPolicy: 'network-only',
      variables() {
        return this.params
      },
      skip() {
        return !this.params.whitelabel_uuid
      }
    },
    gatewayConfig: {
      fetchPolicy: "no-cache",
      query() {
        return GATEWAY_CONFIG_QUERY;
      },
      variables() {
        return {
          whitelabel_uuid: this.getWhiteLabel.uuid,
          module: 'cpay',
        };
      },
      result({ loading, data }) {
        if (!loading) {
          if (data.gatewayConfig) {
            if (
              typeof data.gatewayConfig.config != "object" &&
              data.gatewayConfig.config
            ) {
              data.gatewayConfig.config = JSON.parse(data.gatewayConfig.config);
            }
            this.configGateway = data.gatewayConfig;
          }
        }
      },
      skip() {
        return !this.getWhiteLabel.uuid;
      },
    },
  }
}
</script>

<style lang="scss">


</style>
